
/**
 * ReInit Yotpo Star widget.
 */
{
    const YOTPO_PAGINATION_LIST_SELECTOR = 'ul.yotpo-horizontal-pagination-container, .yotpo-reviews-pagination-container ul';

    function flattenYotpoPaginationList(listEl) {
        if (!listEl || listEl.tagName !== 'UL' || listEl.dataset.a11yPaginationFixed === 'true') {
            return;
        }

        const wrapper = document.createElement('div');
        Array.from(listEl.attributes).forEach(({ name, value }) => {
            wrapper.setAttribute(name, value);
        });
        wrapper.dataset.a11yPaginationFixed = 'true';

        listEl.querySelectorAll(':scope > li').forEach((listItem) => {
            const itemWrapper = document.createElement('div');
            Array.from(listItem.attributes).forEach(({ name, value }) => {
                itemWrapper.setAttribute(name, value);
            });
            while (listItem.firstChild) {
                itemWrapper.appendChild(listItem.firstChild);
            }
            listItem.replaceWith(itemWrapper);
        });

        while (listEl.firstChild) {
            wrapper.appendChild(listEl.firstChild);
        }

        listEl.replaceWith(wrapper);
    }

    function enhanceYotpoReviewsPagination(root = document) {
        root.querySelectorAll(YOTPO_PAGINATION_LIST_SELECTOR).forEach(flattenYotpoPaginationList);
    }

    function initYotpoPaginationA11y() {
        enhanceYotpoReviewsPagination();

        if (window._yotpoPaginationA11yObserver) {
            return;
        }

        window._yotpoPaginationA11yObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== Node.ELEMENT_NODE) {
                        return;
                    }

                    if (node.matches?.(YOTPO_PAGINATION_LIST_SELECTOR)) {
                        flattenYotpoPaginationList(node);
                        return;
                    }

                    enhanceYotpoReviewsPagination(node);
                });
            });
        });

        window._yotpoPaginationA11yObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    const reinitYotpoWidgets = () => {
        const runInit = () => {
            let initialized = false;
            
            if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidget === "function") {
                const widgets = document.querySelectorAll('.yotpo-widget-instance:not([data-yotpo-element-loaded])');
                if (widgets.length > 0) {
                    widgets.forEach(element => {
                        window.yotpoWidgetsContainer.initWidget(element.dataset.yotpoInstanceId, element);
                    });
                }
                initialized = true;
            }
            
            if (window.yotpo && typeof window.yotpo.initWidgets === "function") {
                window.yotpo.initWidgets();
                initialized = true;
            }
            
            return initialized;
        };

        if (runInit()) {
            enhanceYotpoReviewsPagination();
            return;
        }

        let attempts = 0;
        let yotpoInterval = setInterval(() => {
            attempts++;
            if (runInit() || attempts > 20) {
                clearInterval(yotpoInterval);
                enhanceYotpoReviewsPagination();
            }
        }, 500);
    };

    window.reinitYotpo = () => {
        reinitYotpoWidgets();
        window.setTimeout(enhanceYotpoReviewsPagination, 250);
        window.setTimeout(enhanceYotpoReviewsPagination, 1500);
    };

    initYotpoPaginationA11y();
    reinitYotpoWidgets();
}

